import ReferenceEmploymentComparison from '../ReferenceEmploymentComparison';
import { ReferencesPanel } from '../../compliance';

/**
 * Manager-only recruitment reference workarea:
 * 1) compare declared referee/employment history/returned fields side-by-side;
 * 2) make actual satisfactory/unsatisfactory decisions in the canonical panel.
 *
 * A match is NOT a satisfactory reference. Keep the evidence visible without
 * clicking two hidden accordions, or leaving the recruitment page.
 * This read-only comparison never mutates reference or employment records.
 */
export default function ReferencesTabContent({
  employeeId,
  employee,
  onRefresh,
  onEditReference,
}) {
  return (
    <div data-testid="references-tab-content" className="space-y-4">
      <section className="rounded-xl border border-slate-200 bg-white p-3 sm:p-4"
        data-testid="reference-side-by-side-evidence">
        <div className="mb-3">
          <h3 className="text-sm font-semibold text-slate-900">Compare employment history with referees</h3>
          <p className="mt-1 text-xs text-slate-600">
            See which employer was declared, what the applicant recorded in their work history,
            and any differences in the referee's returned name, workplace or email.
            An employer-name match is not an approved reference. Only an authorised manager's
            documented decision below counts towards reference readiness.
          </p>
        </div>
        <ReferenceEmploymentComparison
          key={employeeId}
          employeeId={employeeId}
          onRefresh={onRefresh}
        />
      </section>

      <ReferencesPanel
        employeeId={employeeId}
        employee={employee}
        onRefresh={onRefresh}
        onEditReference={onEditReference}
      />
    </div>
  );
}
